import { useEffect, useRef } from "react";
import { Eraser } from "lucide-react";

export function SignaturePad({ value, onChange }) {
  const ref = useRef(null);
  const drawing = useRef(false);

  useEffect(() => {
    const ctx = ref.current.getContext("2d");
    ctx.fillStyle = "#FFFFFF";
    ctx.fillRect(0, 0, 700, 220);
    if (value) {
      const img = new Image();
      img.onload = () => ctx.drawImage(img, 0, 0, 700, 220);
      img.src = value;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const pos = (e) => {
    const r = ref.current.getBoundingClientRect();
    return [((e.clientX - r.left) / r.width) * 700, ((e.clientY - r.top) / r.height) * 220];
  };
  const down = (e) => {
    drawing.current = true;
    e.currentTarget.setPointerCapture?.(e.pointerId);
    const ctx = ref.current.getContext("2d");
    ctx.beginPath();
    ctx.moveTo(...pos(e));
  };
  const move = (e) => {
    if (!drawing.current) return;
    const ctx = ref.current.getContext("2d");
    ctx.strokeStyle = "#050B10";
    ctx.lineWidth = 2.6;
    ctx.lineCap = "round";
    ctx.lineJoin = "round";
    ctx.lineTo(...pos(e));
    ctx.stroke();
  };
  const up = () => {
    if (!drawing.current) return;
    drawing.current = false;
    onChange(ref.current.toDataURL("image/png"));
  };
  const clear = () => {
    const ctx = ref.current.getContext("2d");
    ctx.fillStyle = "#FFFFFF";
    ctx.fillRect(0, 0, 700, 220);
    onChange("");
  };

  return (
    <div className="flex flex-col gap-2">
      <div className="relative border-2 border-[#1E2F45] rounded-sm overflow-hidden">
        <canvas ref={ref} width={700} height={220} className="w-full bg-white cursor-crosshair" style={{ touchAction: "none", aspectRatio: "700 / 220" }}
          onPointerDown={down} onPointerMove={move} onPointerUp={up} onPointerLeave={up} data-testid="signature-canvas" />
        <div className="absolute bottom-6 left-8 right-8 border-t border-dashed border-slate-400 pointer-events-none" />
      </div>
      <button type="button" onClick={clear} data-testid="signature-clear" className="self-start h-8 px-3 flex items-center gap-2 border border-[#1E2F45] rounded-sm font-mono text-xs text-slate-300 hover:text-white"><Eraser size={14} /> LIMPAR ASSINATURA</button>
    </div>
  );
}
